import React from 'react';
import { ListGroup, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faUser } from '@fortawesome/free-solid-svg-icons';
import UserAvatar from './UserAvatar';
import { formatTimestamp } from '../../utils/dateUtils';
import './ConversationItem.css';

function ConversationItem({ conversation, isSelected, onClick }) {
  const {
    threadType,
    participantDetails = [],
    lastMessage,
    unreadCount = 0,
    messageCount = 0
  } = conversation;

  const isGroupChat = threadType === 'group';
  const displayName = isGroupChat
    ? participantDetails.map(p => p.displayName).join(', ')
    : participantDetails[0]?.displayName || 'Unknown User';

  const truncateMessage = (text, maxLength = 50) => {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  return (
    <ListGroup.Item
      action
      active={isSelected}
      onClick={onClick}
      className={`conversation-item ${unreadCount > 0 ? 'has-unread' : ''}`}
    >
      <div className="d-flex align-items-start">
        <div className="conversation-avatar me-3">
          {isGroupChat ? (
            <div className="group-avatar">
              <FontAwesomeIcon icon={faUsers} />
            </div>
          ) : (
            <UserAvatar
              photoUrl={participantDetails[0]?.photoUrl}
              displayName={participantDetails[0]?.displayName}
              size="md"
            />
          )}
        </div>

        <div className="conversation-content flex-grow-1">
          <div className="d-flex justify-content-between align-items-start mb-1">
            <div className="conversation-name">
              {isGroupChat && (
                <FontAwesomeIcon icon={faUsers} className="me-1 text-muted" size="sm" />
              )}
              <strong className={unreadCount > 0 ? 'fw-bold' : ''}>
                {displayName}
              </strong>
            </div>
            <div className="conversation-time text-muted">
              {lastMessage?.timestamp && formatTimestamp(lastMessage.timestamp)}
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <div className="conversation-preview text-muted">
              {lastMessage?.senderName && (
                <span className="sender-name">{lastMessage.senderName}: </span>
              )}
              {truncateMessage(lastMessage?.content || 'No messages yet')}
            </div>
            {unreadCount > 0 && (
              <Badge bg="primary" pill className="ms-2">
                {unreadCount}
              </Badge>
            )}
          </div>

          {isGroupChat && (
            <div className="conversation-meta text-muted mt-1">
              <FontAwesomeIcon icon={faUser} size="sm" className="me-1" />
              {participantDetails.length} participants · {messageCount} messages
            </div>
          )}
        </div>
      </div>
    </ListGroup.Item>
  );
}

export default ConversationItem;
